import Footer from '@alltrails/shared/components/Footer';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import useUser from 'hooks/useUser';
import useLanguageRegionCode from '@alltrails/shared/hooks/useLanguageRegionCode';
import { handleLanguageChange } from 'utils/language_support_util';
import CustomProvider from '../CustomProvider';

type FooterWrapperProps = {
  wideFooter: boolean;
  isSEOTestingNoFollow?: boolean;
};

const FooterWrapper = ({ wideFooter, isSEOTestingNoFollow = false }: FooterWrapperProps): JSX.Element => {
  const user = useUser();
  const languageRegionCode = useLanguageRegionCode();

  return (
    <Footer
      enabledLanguages={__AT_DATA__.enabledLanguages}
      user={user}
      wideFooter={wideFooter}
      handleLanguageChange={(newLanguageRegionCode: LanguageRegionCode) => handleLanguageChange(user, newLanguageRegionCode)}
      languageRegionCode={languageRegionCode}
      isSEOTestingNoFollow={isSEOTestingNoFollow}
    />
  );
};

export default function Wrapper({ wideFooter, isSEOTestingNoFollow }: FooterWrapperProps) {
  return (
    <CustomProvider>
      <FooterWrapper wideFooter={wideFooter} isSEOTestingNoFollow={isSEOTestingNoFollow} />
    </CustomProvider>
  );
}
